import documentClickedMixin from '@/mixins/component-document-clicked-mixin';

/**
 * @mixin encapsulates split button common functionality
 */
export default {
	mixins: [documentClickedMixin],
	created() {
		this.documentClickedHandler = this.onDocumentClicked;
	},
	data() {
		return {
			expanded: false,
			popperMinWidth: 'auto'
		};
	},
	props: {
		/**
		 * @type Array
		 */
		options: {
			type: Array,
			default: function() {
				return [];
			}
		}
	},
	methods: {
		dropdownOptionSelected(option) {
			this.toggleDropdownVisibility();
			this.$emit('optionClick', option);
		},
		defaultActionHandler() {
			this.expanded && this.toggleDropdownVisibility();
			this.$emit('click');
		},
		toggleDropdownVisibility() {
			this.expanded = !this.expanded;
		},
		onDocumentClicked() {
			this.expanded && this.toggleDropdownVisibility();
		},
		setpopperMinWidth(value) {
			this.popperMinWidth = value;
		}
	}
};
